export class FilterHandler {
  constructor() {
    this.productContainer = document.querySelector('.product-area__list');
    this.subfiltersContainer = document.querySelector('.subfilter-buttons');
  }

  init(filtersUrl, subfiltersUrl, hasSubfilters = true) {
    this.filtersUrl = filtersUrl;
    this.subfiltersUrl = subfiltersUrl;
    this.hasSubfilters = hasSubfilters;
    this.loading();
  }

  fetchData(url) {
    return fetch(url, {
      headers: {
        'Accept': 'application/json'
      }
    }).then((response) => response.json());
  }

  loading() {
    if (this.hasSubfilters) {
      this.subfiltersContainer.innerHTML = '';
    }
    this.clearProductContainer();

    this.fetchData(this.filtersUrl)
      .then((data) => {
        if (this.hasSubfilters) {
          this.generateSubfilterButtons(data.subfilters);
        }
        this.generateProducts(data.data);
      })
      .catch((error) => console.error('Ошибка загрузки фильтров:', error));

    this.addFilterEventListener();
  }

  clearProductContainer() {
    this.productContainer.innerHTML = '';
    const loadingElement = this.generateLoading();
    this.productContainer.appendChild(loadingElement);
  }

  generateLoading() {
    const iconLoading = document.createElement('div');
    iconLoading.classList.add('product-area__icon-loading');

    iconLoading.innerHTML = `
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid" width="50" height="50" style="shape-rendering: auto; display: block; background: rgb(244, 246, 248);" xmlns:xlink="http://www.w3.org/1999/xlink">
        <circle stroke-dasharray="164.93361431346415 56.97787143782138" r="35" stroke-width="10" stroke="#272f6a" fill="none" cy="50" cx="50">
          <animateTransform keyTimes="0;1" values="0 50 50;360 50 50" dur="1s" repeatCount="indefinite" type="rotate" attributeName="transform"></animateTransform>
        </circle>
      </svg>
    `;

    return iconLoading;
  }

  generateSubfilterButtons(subfilters) {
    this.subfiltersContainer.innerHTML = '';

    subfilters.forEach((subfilter, index) => {
      const button = this.createSubfilterButton(subfilter);
      this.subfiltersContainer.appendChild(button);

      button.addEventListener('click', () => {
        this.subfiltersContainer
          .querySelectorAll('.product-area__button')
          .forEach((btn) =>
            btn.classList.remove('product-area__button--active')
          );
        button.classList.add('product-area__button--active');

        const filterValue = button.getAttribute('data-filter');
        const categoryButton = document.querySelector(
          '.product-area__filter-buttons .product-area__button--active'
        );
        const category = categoryButton
          ? categoryButton.getAttribute('data-filter')
          : 'all';

        this.clearProductContainer();
        this.loadProductsBySubCategory(category, filterValue);
      });
    });
  }

  createSubfilterButton(subfilter) {
    const button = document.createElement('button');
    button.classList.add(
      'product-area__button',
      'button',
      'button-primory',
      'button_invert'
    );
    button.setAttribute('type', 'button');
    button.setAttribute('data-filter', subfilter);
    button.textContent = subfilter;

    return button;
  }

  addFilterEventListener() {
    const filterButtons = document.querySelectorAll(
      '.filter-buttons .product-area__button'
    );
    filterButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const filterContainer = document.querySelector('.filter-buttons');

        filterContainer
          .querySelectorAll('.product-area__button')
          .forEach((btn) =>
            btn.classList.remove('product-area__button--active')
          );
        button.classList.add('product-area__button--active');

        const filterValue = button.getAttribute('data-filter');

        if (this.hasSubfilters) {
          this.subfiltersContainer.innerHTML = '';
        }

        this.clearProductContainer();
        this.loadProductsByCategory(filterValue);
      });
    });
  }

  loadProductsByCategory(category) {
    let url = this.filtersUrl;
    if (category !== 'all') {
      const queryParams = `?search[bcc8b697a5070a9a191f7fa72a33d185]=${category}`;
      url += queryParams;
    }

    return this.fetchData(url)
      .then((data) => {
        if (this.hasSubfilters) {
          this.generateSubfilterButtons(data.subfilters);
        }
        this.generateProducts(data.data);
      })
      .catch((error) => console.error('Ошибка загрузки продуктов:', error));
  }

  loadProductsBySubCategory(category, subcategory) {
    if (!this.hasSubfilters) {
      return;
    }

    this.clearProductContainer();

    let url = this.subfiltersUrl;
    if (category !== 'all') {
      const queryParams = `?search[bcc8b697a5070a9a191f7fa72a33d185]=${category}&search[1f02f6eb6f26722219641395395e328c]=${subcategory}`;
      url += queryParams;
    } else {
      const queryParams = `?search[1f02f6eb6f26722219641395395e328c]=${subcategory}`;
      url += queryParams;
    }

    this.fetchData(url)
      .then((data) => {
        this.generateProducts(data.data);
      })
      .catch((error) => console.error('Ошибка загрузки продуктов:', error));
  }

  generateProducts(products) {
    this.productContainer.innerHTML = '';

    products.forEach((product) => {
      const li = this.createProduct(product);
      this.productContainer.appendChild(li);
    });
  }

  createProduct(product) {
    const li = document.createElement('li');
    li.classList.add('product-area__item');

    const productCard = document.createElement('a');
    productCard.classList.add('product-card', 'link');
    productCard.href = product.link;

    const imgWrapper = document.createElement('div');
    imgWrapper.classList.add('product-card__img-wrapper');

    const picture = document.createElement('picture');
    imgWrapper.appendChild(picture);

    const source = document.createElement('source');
    source.type = 'image/webp';
    source.srcset = `${product.imageWebp} 1x, ${product.imageWebp2x} 2x`;
    source.width = '100';
    source.height = '127';
    picture.appendChild(source);

    const img = document.createElement('img');
    img.src = product.image;
    img.srcset = `${product.image2x} 2x`;
    img.alt = product.title;
    img.width = '100';
    img.height = '127';
    img.loading = 'lazy';
    picture.appendChild(img);

    const cardBlock = document.createElement('div');
    cardBlock.classList.add('product-card__card-block');

    const cardTitle = document.createElement('div');
    cardTitle.classList.add('product-card__card-title');
    cardTitle.textContent = product.title;

    const moreLink = document.createElement('div');
    moreLink.classList.add('product-card__more-link');

    const moreLinkSpan = document.createElement('span');
    moreLinkSpan.textContent = 'Подробнее';

    const moreLinkSvg = document.createElementNS(
      'http://www.w3.org/2000/svg',
      'svg'
    );
    moreLinkSvg.setAttribute('width', '24');
    moreLinkSvg.setAttribute('height', '24');
    moreLinkSvg.setAttribute('fill', 'currentColor');
    moreLinkSvg.setAttribute('xmlns', 'http://www.w3.org/2000/svg');

    const svgPath = document.createElementNS(
      'http://www.w3.org/2000/svg',
      'path'
    );
    svgPath.setAttribute(
      'd',
      'M13.828 5.719c-.066.065-.094.154-.094.29v.202l2.705 2.705 2.71 2.709H11.54c-7.543 0-7.604 0-7.697.094-.127.126-.127.436 0 .562.093.094.154.094 7.697.094h7.607l-2.709 2.71-2.705 2.704v.202c0 .262.122.384.385.384h.201l2.85-2.845c1.57-1.57 2.906-2.94 2.972-3.052a.99.99 0 0 0 0-.956c-.066-.113-1.401-1.481-2.972-3.052l-2.85-2.845h-.201c-.136 0-.225.028-.29.094Z'
    );

    moreLinkSvg.appendChild(svgPath);
    moreLink.appendChild(moreLinkSpan);
    moreLink.appendChild(moreLinkSvg);

    cardBlock.appendChild(cardTitle);
    cardBlock.appendChild(moreLink);

    productCard.appendChild(imgWrapper);
    productCard.appendChild(cardBlock);

    li.appendChild(productCard);

    return li;
  }
}
